import React, { createContext, useEffect, useState, ReactNode } from 'react';
import axios from 'axios';

export interface Subject {
  _id: string;
  name: string;
  intro: string;
  description: string;
  r: string | null;
  c: string | null;
  l: string | null;
}

interface SubjectContextProps {
  subjects: Subject[];
  loading: boolean;
  show: boolean;
  selectedSubject: string;
  setSelectedSubject: (subject: string) => void;
}


export const SubjectContext = createContext<SubjectContextProps>({
  subjects: [],
  loading: true,
  show:false,
  selectedSubject: "",
  setSelectedSubject: () => {},
});

export const SubjectProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState<string>("");

 const API_BASE_URL = 
    window.location.hostname === "localhost"
      ? "http://localhost:3500/api"
      : `${window.location.protocol}//mywacademy-server.onrender.com/api`;

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/allsubjects`);

const data = Array.isArray(res.data)
  ? res.data
  : Array.isArray(res.data?.subjects)
  ? res.data.subjects
  : [];

setSubjects(data);
        setSubjects(res.data);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSubjects();
  }, []);

  return (
    <SubjectContext.Provider
      value={{ subjects, loading, show, selectedSubject, setSelectedSubject }}
    >
      {children}
    </SubjectContext.Provider>
  );
};
